import React from 'react'

import { Icon, CubeAIOutline, Community } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { arrayOf, shape, string, bool, number, oneOfType } from 'prop-types'

import FreeTrialTag from 'Pods/UnifiedNavigation/Shared/FreeTrialTag/FreeTrialTag'

import { EMPTY_ARRAY, EMPTY_OBJECT } from 'Utils/stableDefaults'

import GenerationResult from './Components/GenerationResult/GenerationResult'

const ICON_SIZE = { width: '20', height: '20' }

// String icon keys (from the backend `create_ai_links`) -> Triangle UI glyphs.
const ICON_MAP = { cube_ai: CubeAIOutline, community: Community }

// "Create with AI" dropdown panel: a flat list anchored to the Create with AI
// trigger. Reuses the shared `.unified-nav__dropdown` card so it matches the
// Sellers Hub panel and renders in-flow inside the stacked mobile hamburger.
// The FREE TRIAL tag shows while a free trial is in progress or still attainable
// for the viewer (see Generator::SubscriptionState::FREE_TRIAL_TAG_TIERS). Every
// finished 3D-model generation the user has not opened yet stacks a result row
// below the links (paid tiers can run several generations concurrently).
function CreateAiDropdown({
  id = undefined,
  links = EMPTY_ARRAY,
  showFreeTrialTag = false,
  lastResults = EMPTY_ARRAY,
  labels = EMPTY_OBJECT,
}) {
  return (
    <div className="unified-nav__dropdown" id={id}>
      <ul className="unified-nav__dropdown-list">
        {links.map((link) => {
          const IconComponent = ICON_MAP[link.icon]

          return (
            <li key={link.id} className="unified-nav__dropdown-item">
              <a
                className="unified-nav__dropdown-link cgt-body-base-semibold"
                href={link.href}
                data-track-label="Create with AI"
                data-track-text={link.trackText}
              >
                <span className="unified-nav__dropdown-item-icon">
                  {IconComponent && (
                    <Icon notSpaced color="dark" size={ICON_SIZE} svgComponent={IconComponent} />
                  )}
                </span>
                <span className="unified-nav__dropdown-item-label">{link.title}</span>
                {showFreeTrialTag && link.tag && <FreeTrialTag label={link.tag} />}
              </a>
            </li>
          )
        })}
      </ul>
      {lastResults.length > 0 && (
        <div className="unified-nav__dropdown-result-section">
          {lastResults.map((result) => (
            <GenerationResult
              key={result.runId ?? result.pathname}
              result={result}
              labels={labels}
            />
          ))}
        </div>
      )}
    </div>
  )
}

CreateAiDropdown.propTypes = {
  id: string,
  links: arrayOf(shape({
    id: string,
    href: string,
    title: string,
    trackText: string,
    icon: string,
    tag: string,
  })),
  showFreeTrialTag: bool,
  lastResults: arrayOf(shape({
    runId: oneOfType([number, string]),
    status: string,
    pathname: string,
    previewUrl: string,
  })),
  labels: shape({
    readyTitle: string,
    errorTitle: string,
    errorHref: string,
  }),
}

export default CreateAiDropdown
